<template>
  <a-modal width="35%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>配置发票税点</b>
    </a-divider>
    <a-button  type="primary" style="width: 20%" @click="addGoodsCount()" class="margin-bottom">
      <a-icon type="plus"/>
      添加
    </a-button>
    <a-table :data-source="invoiceTaxList" :columns="skuColumns" :pagination="false" bordered>
      <div slot="discount" slot-scope="text, record">
        <a-input-number v-model="record.tax"
                        :min="0" :max="1" :step="0.01"
                        :formatter="(value) => `${value}`.replace(/\.00$/, '')"
                        :parser="(value) => value.replace(/\.00$/, '')"
                        :placeholder="$t('请输入')+'税点'"  />
      </div>
      <span slot="invoiceName" slot-scope="text, record">
         <a-input v-model="record.invoiceName"
                         style="width: 90%"
                         :placeholder="$t('请输入')+'名称'"  />
      </span>
      <div slot="discountTitle">
        税点
        <a-tooltip>
          <template slot="title">
            <p>请输入0-1之间的数字</p>
          </template>
          <a-icon type="question-circle" />
        </a-tooltip>
      </div>
    </a-table>
  </a-modal>
</template>

<script>
import CustomDictTag from "@/components/DictCustomTag";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      invoiceTaxList:[
      ],
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      errorMessage:undefined,
      skuColumns: [
        {
          title: '名称',
          dataIndex: 'invoiceName',
          scopedSlots: {customRender: 'invoiceName'},
          key: 'invoiceName',
        },
        {
          slots: { title: 'discountTitle' },
          dataIndex: 'discount',
          key: 'discount',
          scopedSlots: {customRender: 'discount'}
        }
      ],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.invoiceTaxList = [
      ]
    },
    /** 修改按钮操作 */
    show(invoiceTaxList) {
      if (invoiceTaxList && invoiceTaxList.length > 0) {
        this.invoiceTaxList = invoiceTaxList;
      }
      this.open = true
    },
    addGoodsCount() {
      const newData = {
        invoiceName: null,
        tax: 0
      };
      this.invoiceTaxList.push(newData);
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('invoiceTax', this.invoiceTaxList)
      this.reset()
    },
  }
}
</script>
